
define('text!features/offlineMessage/offlineMessage.html',[],function () { return '<div class="offline-message">\n    {{{ noConnectionMessage }}}\n</div>';});

